import React from "react";

const InternalServerError = () => {
  return (
    <div className="fetch-status-label">
      <p>Pogreška u čitanju podataka sa servera, molimo kontaktirajte podršku</p>
    </div>
  );
};

export default InternalServerError;
